// extracted by mini-css-extract-plugin
export default {"label":"TextareaField_label__DVHoQ","textArea":"TextareaField_textArea__VPLwJ"};